import "client-only";

import { eventClient } from "@/lib/connect.client";
import {
  cancelRegistrationWithClient,
  getRegistrationStatusWithClient,
  listAttendeesWithClient,
  registerEventWithClient,
} from "./attendees.base";

/**
 * listAttendeesClient lists attendees for an event.
 */
export const listAttendees = listAttendeesWithClient(eventClient);

/**
 * registerEventClient handles registration actions for an event.
 */
export const registerEvent = registerEventWithClient(eventClient);

/**
 * getRegistrationStatusClient gets the current user's registration status for an event.
 */
export const getRegistrationStatus =
  getRegistrationStatusWithClient(eventClient);

/**
 * cancelRegistrationClient cancels the current user's registration for an event.
 */
export const cancelRegistration = cancelRegistrationWithClient(eventClient);
